import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { WaterInfoImageType } from '@models/water-image-types';
import type { WaterInformationDetail, WaterInformationSaveRequest } from '@models/water-information';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrmWaterInformationService {
  private readonly http = inject(HttpClient);

  private url(waterId: number): string {
    return `${environment.apiUrl}/api/crm/waters/${waterId}/information`;
  }

  get(waterId: number): Observable<WaterInformationDetail> {
    return this.http.get<WaterInformationDetail>(this.url(waterId));
  }

  save(waterId: number, dto: WaterInformationSaveRequest): Observable<WaterInformationDetail> {
    return this.http.put<WaterInformationDetail>(this.url(waterId), dto);
  }

  uploadInfoImage(waterId: number, type: WaterInfoImageType, file: File): Observable<WaterInformationDetail> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<WaterInformationDetail>(`${this.url(waterId)}/images/${type}`, formData);
  }

  deleteInfoImage(waterId: number, type: WaterInfoImageType): Observable<void> {
    return this.http.delete<void>(`${this.url(waterId)}/images/${type}`);
  }

  uploadHotspotImage(waterId: number, hotspotId: number, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${this.url(waterId)}/hotspots/${hotspotId}/image`, formData);
  }

  uploadContentBlockImage(waterId: number, blockId: number, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${this.url(waterId)}/content-blocks/${blockId}/image`, formData);
  }
}
